// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRP_header__2UPXf","image-wrapper":"infoRP_image-wrapper__1lmnt"};